/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
import React from "react";
import styles from "./index.module.css";
import TopNavigation from "./TopNavigation";
import Footer from "./FooterSection";
import StepsSection from "./StepsSection";

const Layout = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.topNav}>
        <TopNavigation />
      </div>
      <div className={styles.stepsSec}>
        <StepsSection />
      </div>
      <div className={styles.topNav}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
